export const UPDATE_SUBMIT_REQUEST = "UPDATE_SUBMIT_REQUEST"
export const UPDATE_LOADING_CONTACT_US = "UPDATE_LOADING_CONTACT_US"